import React, { Component } from 'react'
import Footer from '../../component/Footer/Footer'
import LayoutWrapper from '../../component/LayoutWrapper/'
import './ForgetPassword.css'
import { compose } from 'redux';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import {passwordForgot, doForgotPasswordRes} from '../../action/ForgotPasswordAction'
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';


var pattern = /^[+a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/i;

 class ForgetPassword extends Component {

    constructor(){
        super();
        this.state = {
            isSubmited: false,
            email: '',
        }
        ReactGA.initialize('UA-64201999-5');
        ReactGA.pageview(window.location.pathname + window.location.search);

        ReactPixel.init('784849368913134');

        ReactPixel.pageView();
    }

    validate(values) {
        const errors = {};  
        if (values.email && values.email.trim() === '') {
            errors.email = '*Please enter emailid';
        }else if(values.email === undefined){
            errors.email = '*Please enter emailid';
        }else if(values.email === ''){
            errors.email = '*Please enter emailid';
        }else if(values.email === null){
            errors.email = '*Please enter emailid';
        }else if (!pattern.test(values.email)) {
            errors.email = "*Please enter valid email address.";
        }
        return errors;      
    }

    resetPasswordSubmit = e =>{
        e.preventDefault();
        this.setState({
            isSubmited: true,        
        }, () => { });
        this.validate(this.state);
        const errors = this.validate(this.state);
        if (Object.keys(errors).length === 0) { 
            let requestData = {
                email: this.state.email,
            }
            this.setState({
                // isLoader: true
            })
            this.props.passwordForgot(requestData)
        }

    }

    componentWillReceiveProps(nextProps){
        if(nextProps.doForgotPasswordRes && nextProps.doForgotPasswordRes.user){
            if(nextProps.doForgotPasswordRes.user && nextProps.doForgotPasswordRes.user.ForgotPasswordRes){
                if(nextProps.doForgotPasswordRes.user.ForgotPasswordRes && nextProps.doForgotPasswordRes.user.ForgotPasswordRes.result === true){
                    this.props.history.push('/verify-forgotpassword', {
                        email: this.state.email
                    })
                }
            }
        }
    }

    render() {

        const { isSubmited, } = this.state;
        const errors = this.validate(this.state);

        return (
            
            <React.Fragment>
                <LayoutWrapper />

                    <main className="main">
                        <nav aria-label="breadcrumb" className="breadcrumb-nav">
                            <div className="container">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                                    <li className="breadcrumb-item active" aria-current="page">Forgot Password</li>
                                </ol>
                            </div>
                             {/* End .container  */}
                        </nav>

                        <div className="container">
                            <div className="heading mb-4">
                                <h2 className="title">Forgot Password</h2>
                                <p>Please enter your email address below to receive a email.</p>
                            </div>
                             {/* End .heading  */}

                            <form onSubmit = {this.resetPasswordSubmit}>
                                <div className="form-group required-field">
                                    <label htmlFor="reset-email">Email</label>
                                    <input type="email" className="form-control" id="reset-email" name="reset-email" onChange = {(e) => this.setState({email: e.target.value})} value = {this.state.email} autoComplete='off' />
                                    {errors && isSubmited && <span className="error-message">{errors.email}</span>}
                                </div>
                                 {/* End .form-group */}

                                <div className="form-footer">
                                    <button type="submit" className="btn btn-primary show-color">Forgot Password</button>
                                </div>
                                 {/* End .form-footer */}
                            </form>
                        </div>
                         {/* End .container */}

                        <div className="mb-10"></div>
                         {/* margin */}
                    </main>
                     {/* End .main  */}
                <Footer />
            </React.Fragment>
        )
    }
}

ForgetPassword.propTypes = {
    doForgotPasswordRes: PropTypes.any,
};

const mapStateToProps = createStructuredSelector({
    doForgotPasswordRes: doForgotPasswordRes,
});

function mapDispatchToProps(dispatch) {
    return {
        passwordForgot: (data) => dispatch(passwordForgot(data)),
    };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(ForgetPassword)